import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/shared/services/auth.service";
import {
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { ValidEmailRegex } from "../../../shared/regex";

@Component({
    selector: "app-forget-pwd",
    templateUrl: "./forget-pwd.component.html",
    styleUrls: ["./forget-pwd.component.scss"],
    standalone: false
})
export class ForgetPwdComponent implements OnInit {
  /** Form object for recovery password */
  protected forgotPasswordForm: FormGroup;

  /** Email regex */
  protected validEmailRegex = ValidEmailRegex;

  /** Flag to check if module is loading */
  protected isLoading: boolean = false;

  /** Flag to show or hide that the recovery message was sent ok */
  protected showSentMessage: boolean = false;

  /** Flag to show or hide that the recovery message was not sent */
  protected showMessageNotSent: boolean = false;

  /**
   * Chacks for errors Flag
   * Use to check for error only after an action. So the error messages of the form
   * will not show until and action is taken.
   */
  protected checkErrors: boolean = false;

  constructor(private authService: AuthService) {
    // Set's up the recovery password form
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl<string>("", {
        validators: [Validators.required, Validators.pattern(ValidEmailRegex)],
      }),
    });
  }

  ngOnInit() {}

  /**
   * Calls the recovery option on the Auth object to send a recovery password to the given email
   */
  recoveryPassword() {
    // Activate the check for errors
    this.checkErrors = true;
    if (this.forgotPasswordForm.valid) {
      this.isLoading = true;
      this.showSentMessage = false;
      this.showMessageNotSent = false;
      this.authService
        ._sendPasswordResetEmail(this.getFormControl("email")?.value)
        .then((emailSent) => {
          if (emailSent) {
            this.showSentMessage = true;
            this.showMessageNotSent = false;
          } else {
            this.showMessageNotSent = true;
            this.showSentMessage = false;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  /**
   * Gets a value from the form control
   * @param controlName The name of the control in the form to get.
   * @returns The expected control or null if the control does not exists.
   */
  getFormControl(controlName: string): AbstractControl | null {
    return this.forgotPasswordForm.get(controlName);
  }
}
